<template>
  <div class="PEC_title">
    <!-- 标题组件 -->
    <h2 v-html="text"></h2>
  </div>
</template>

<script>
export default {
  props: ['text'],
  mounted() {
    this.observeElement();
  },
  methods: {
    observeElement() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateIn();
          }
        });
      });
      observer.observe(this.$el);
    },
    animateIn() {
      // 触发CSS过渡效果
            // 触发CSS过渡效果
            let 渐变元素 = this.$el.querySelectorAll('h2');
            // 随机出现时间
            let currentDelay = 500+1000 * Math.random();

            渐变元素.forEach((item) => {
                // 设置延迟时间，每次迭代增加0.4秒
                setTimeout(() => {
                    item.style.opacity = '1';
                    item.style.transform = 'translateY(0)';
                }, currentDelay);

                // 更新延迟时间，为下一次迭代准备
                currentDelay += 500+300*Math.random(); // 0.2秒转换为毫秒
            });
    }
  }
}
</script>

<style scoped>
.PEC_title h2 {
  white-space: pre-wrap;
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  line-height: 1.2;
  color: #333;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.8);
  opacity: 0; /* 开始时透明度为0 */
  transform: translateY(2em); /* 开始时向上移动 */
  transition: all 1s ease; /* 定义CSS过渡效果 */
}
.PEC_title {
  padding-left: 10%;
  padding-right: 10%;
  width: 100%-20%;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>